export enum SaleStatus {
  UNSUCCESSFUL = 'Unsuccessful',
  COMPLETE = 'Complete',
  CANCELED = 'Canceled',
  CHANGED = 'Changed',
  VOID = 'Void',
}
